import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	close: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	giveFeedback: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	link: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkDisabledGic: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	remove: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openInNewTab: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	linkAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	close: {
		id: 'ai-related-issues.related-issues-draft-list.close',
		defaultMessage: 'Close',
		description: 'Text for button which closes the ai provided suggestions',
	},
	giveFeedback: {
		id: 'ai-related-issues.related-issues-draft-list.give-feedback',
		defaultMessage: 'Give feedback',
		description: 'Text for button used to provide feedback',
	},
	link: {
		id: 'ai-related-issues.related-issues-draft-list.link',
		defaultMessage: 'Link',
		description: 'Text for button used to link related issue',
	},
	linkDisabledGic: {
		id: 'ai-related-issues.related-issues-draft-list.link-disabled-gic',
		defaultMessage: 'There is no linked work items field configured hence linking is disabled',
		description: 'Text for button used to link related issue',
	},
	remove: {
		id: 'ai-related-issues.related-issues-draft-list.remove',
		defaultMessage: 'Remove',
		description: 'Text for button used to remove related issue',
	},
	openInNewTab: {
		id: 'ai-related-issues.related-issues-draft-list.openInNewTab',
		defaultMessage: 'Open in new tab',
		description: 'Text for button used to open issue in new tab',
	},
	linkAll: {
		id: 'ai-related-issues.related-issues-draft-list.link-all',
		defaultMessage: 'Link all',
		description: 'Text for button used to link all the ai provided suggestions',
	},
});
export default messages;
